module.exports = __webpack_public_path__ + "img/mt5-icon10.173768a.png";